import { render, staticRenderFns } from "./ConsultantProfile.vue?vue&type=template&id=09ec936e&"
import script from "./ConsultantProfile.vue?vue&type=script&lang=ts&"
export * from "./ConsultantProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports